/* Breadwright Founders Presale landing pages — countdown, sticky CTA, add-to-cart → checkout */
document.addEventListener('DOMContentLoaded', function () {

  /* ---- Countdown to the presale deadline ---- */
  (function () {
    var clocks = [].slice.call(document.querySelectorAll('.lp-count[data-deadline]'));
    if (!clocks.length) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      clocks.forEach(function (c) {
        var end = new Date(c.getAttribute('data-deadline')).getTime();
        var diff = Math.max(0, end - Date.now());
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        var setEl = function (sel, val) { var el = c.querySelector(sel); if (el) el.textContent = val; };
        setEl('[data-d]', d); setEl('[data-h]', pad(h)); setEl('[data-m]', pad(m)); setEl('[data-s]', pad(s));
      });
    }
    tick(); setInterval(tick, 1000);
  })();

  /* ---- Count up the hero number (0 → target) on load ---- */
  (function () {
    var els = [].slice.call(document.querySelectorAll('[data-countup]'));
    if (!els.length) return;
    els.forEach(function (el) {
      var target = parseInt(el.getAttribute('data-countup'), 10) || 0;
      var dur = 1600, start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
        el.textContent = Math.round(eased * target);
        if (p < 1) { requestAnimationFrame(step); } else { el.textContent = target; }
      }
      requestAnimationFrame(step);
    });
  })();

  /* ---- Sticky buy bar reveal on scroll ---- */
  (function () {
    var bar = document.getElementById('lpBuybar');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      var nearBottom = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 200);
      bar.classList.toggle('show', window.scrollY > 620 && !nearBottom);
    }, { passive: true });
  })();

  /* ---- CTA: add Founder's Box (subscription) then go straight to checkout ---- */
  (function () {
    var ctas = [].slice.call(document.querySelectorAll('.lp-cta'));
    if (!ctas.length) return;
    ctas.forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        var vid = cta.getAttribute('data-variant');
        if (!vid) { return; } // product not wired yet → follow href fallback
        e.preventDefault();
        var item = { id: Number(vid), quantity: 1 };
        var sp = cta.getAttribute('data-selling-plan');
        if (sp) { item.selling_plan = Number(sp); }
        var original = cta.innerHTML;
        cta.style.pointerEvents = 'none';
        cta.setAttribute('aria-busy', 'true');
        cta.innerHTML = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () {
            cta.style.pointerEvents = '';
            cta.removeAttribute('aria-busy');
            cta.innerHTML = original;
            window.location.href = cta.getAttribute('href');
          });
      });
    });
  })();

  /* ---- Subscribe & Save frequency picker: retargets every subscription CTA ---- */
  (function () {
    var freqs = [].slice.call(document.querySelectorAll('.lp-freq'));
    if (!freqs.length) return;
    freqs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var plan = btn.getAttribute('data-selling-plan');
        if (!plan) return;
        freqs.forEach(function (b) { b.classList.toggle('on', b === btn); });
        // Only subscription CTAs carry data-selling-plan; the one-time button never does.
        document.querySelectorAll('.lp-cta[data-selling-plan]').forEach(function (cta) {
          cta.setAttribute('data-selling-plan', plan);
        });
      });
    });
  })();

});
